// src/pages/LoginEmail.js
import React, { useState } from 'react';
import { Form, Button, Container, Card } from 'react-bootstrap';
import { useDispatch } from 'react-redux';
import { verifyEmail } from '../redux/actions/authActions';
import { useNavigate } from 'react-router-dom';
import logo from '../assets/logos/PRV-Website-Logo-Original.webp';

function LoginEmail() {
  const [email, setEmail] = useState('');
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    const success = await dispatch(verifyEmail(email));
    if (success) {
      navigate('/login/password', { state: { email } });
    }
    // On failure, a generic error toast will be shown
  };

  return (
    <Container className="d-flex justify-content-center align-items-center" style={{ minHeight: '80vh' }}>
      <Card style={{ width: '400px' }}>
        <Card.Body>
          <Card.Img variant="top" src={logo} style={{ padding: '30px', background: 'radial-gradient(circle,rgb(44, 44, 51) 0%,rgb(0, 0, 0) 100%)', borderRadius: "10px", marginBottom: "20px" }}/>
          <Card.Title>Login - Step 1: Email</Card.Title>
          <Form onSubmit={handleSubmit}>
            <Form.Group controlId="formEmail">
              <Form.Label>Email address</Form.Label>
              <Form.Control
                type="email"
                placeholder="Enter email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
            </Form.Group>
            <Button variant="primary" type="submit" className="mt-3">
              Next
            </Button>
          </Form>
        </Card.Body>
      </Card>
    </Container>
  );
}

export default LoginEmail;
